import { c as _c } from "react/compiler-runtime";
// Иконки шапки, нижнего меню и чата из Figma «OSMIX ЛК Покупателя» (cHkTZXVaiia41bQ9HlRF7O),
// выгрузка SVG 02.10.2026. Цвет — currentColor (задаётся text-*), размер — проп size.
// Файл собран скриптом из audit/DS/icons-svg: правьте рисунок там и пересобирайте.
import { type IconProps, Svg } from "./icon";

/** Сердце (контур): шапка, нижнее меню, «В избранное». Figma: «Outline/Heart». */
export function HeartIcon(t0) {
  const $ = _c(8);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M3.82344 12.1232C5.22544 16.4852 10.7644 20.0122 12.2364 20.8852C13.7134 20.0032 19.2924 16.4372 20.6494 12.1272C21.5404 9.34117 20.7134 5.81217 17.4274 4.75317C15.8354 4.24217 13.9784 4.55317 12.6964 5.54517C12.4284 5.75117 12.0564 5.75517 11.7864 5.55117C10.4284 4.53017 8.65444 4.23117 7.03744 4.75317C3.75644 5.81117 2.93244 9.34017 3.82344 12.1232ZM12.238 22.5011C12.114 22.5011 11.991 22.4711 11.879 22.4101C11.566 22.2391 4.19296 18.1751 2.39596 12.5811C2.39496 12.5811 2.39496 12.5801 2.39496 12.5801C1.26696 9.05812 2.52296 4.63212 6.57796 3.32512C8.48196 2.70912 10.557 2.98012 12.235 4.03912C13.861 3.01112 16.021 2.72712 17.887 3.32512C21.946 4.63412 23.206 9.05912 22.079 12.5801C20.34 18.1101 12.913 22.2351 12.598 22.4081C12.486 22.4701 12.362 22.5011 12.238 22.5011Z" fill="currentColor" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M18.1547 10.6253C17.7677 10.6253 17.4397 10.3283 17.4077 9.93626C17.3417 9.11426 16.7917 8.42026 16.0087 8.16726C15.6137 8.03926 15.3977 7.61626 15.5247 7.22326C15.6537 6.82926 16.0727 6.61526 16.4687 6.73926C17.8317 7.18026 18.7867 8.38726 18.9037 9.81426C18.9367 10.2273 18.6297 10.5893 18.2167 10.6223C18.1957 10.6243 18.1757 10.6253 18.1547 10.6253Z" fill="currentColor" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props || $[6] !== size) {
    t4 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}{t3}</Svg>;
    $[5] = props;
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}

/** Сумка-корзина: шапка, нижнее меню. Figma: «bag New». */
export function BagIcon(t0) {
  const $ = _c(13);
  let props;
  let strokeWidth;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      strokeWidth,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = strokeWidth;
    $[3] = t1;
  } else {
    props = $[1];
    strokeWidth = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 24 : t1;
  const t2 = strokeWidth ?? 1.5;
  let t3;
  if ($[4] !== t2) {
    t3 = <path d="M7.79102 5.90218C8.38268 3.26459 10.6774 1.64996 12.7952 2.06468C14.4541 2.39092 15.8254 3.91708 16.1959 5.90218H16.207" stroke="currentColor" strokeMiterlimit="10" strokeWidth={t2} />;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const t4 = strokeWidth ?? 1.5;
  let t5;
  if ($[6] !== t4) {
    t5 = <path d="M4.47754 6.01953L19.3955 6.08105C19.5111 6.08156 19.5973 6.1873 19.5752 6.30078L19.2373 8.03418C18.5672 11.4636 18.8342 15.0102 20.0098 18.3008L20.9746 21.0029C21.0175 21.123 20.9283 21.25 20.8008 21.25H3.16699C3.04159 21.2498 2.95301 21.1269 2.99219 21.0078L4.00293 17.96C5.02343 14.8826 5.25837 11.5984 4.68555 8.40723L4.29492 6.23633C4.27458 6.12298 4.36239 6.01909 4.47754 6.01953Z" stroke="currentColor" strokeWidth={t4} />;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== props || $[9] !== size || $[10] !== t3 || $[11] !== t5) {
    t6 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t3}{t5}</Svg>;
    $[8] = props;
    $[9] = size;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}

/** Чат: шапка, нижнее меню (активный — тот же контур цветом #FA5C2E). Figma: «Outline/Chat». */
export function ChatIcon(t0) {
  const $ = _c(10);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M6.10886 19.675C6.68886 19.675 7.23586 19.895 7.81486 20.128C11.3619 21.768 15.5569 21.022 18.2899 18.29C21.8959 14.682 21.8959 8.813 18.2899 5.207C16.5439 3.461 14.2219 2.5 11.7499 2.5C9.27686 2.5 6.95386 3.462 5.20886 5.208C2.47486 7.94 1.73086 12.135 3.35586 15.648C3.58986 16.227 3.81586 16.791 3.81586 17.377C3.81586 17.962 3.61486 18.551 3.43786 19.071C3.29186 19.499 3.07086 20.145 3.21286 20.287C3.35186 20.431 4.00186 20.204 4.43086 20.057C4.94586 19.881 5.52986 19.679 6.10886 19.675ZM11.7244 22.494C10.1964 22.494 8.65844 22.171 7.21944 21.505C6.79544 21.335 6.39844 21.175 6.11344 21.175C5.78544 21.177 5.34444 21.329 4.91844 21.476C4.04444 21.776 2.95644 22.15 2.15144 21.348C1.34944 20.545 1.71944 19.46 2.01744 18.587C2.16444 18.157 2.31544 17.713 2.31544 17.377C2.31544 17.101 2.18244 16.749 1.97844 16.242C0.105437 12.197 0.971437 7.322 4.14844 4.147C6.17644 2.118 8.87544 1 11.7484 1C14.6214 1 17.3214 2.117 19.3494 4.146C23.5414 8.338 23.5414 15.158 19.3494 19.35C17.2944 21.406 14.5274 22.494 11.7244 22.494Z" fill="currentColor" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M15.6954 13.1631C15.1434 13.1631 14.6914 12.7161 14.6914 12.1631C14.6914 11.6101 15.1344 11.1631 15.6864 11.1631H15.6954C16.2474 11.1631 16.6954 11.6101 16.6954 12.1631C16.6954 12.7161 16.2474 13.1631 15.6954 13.1631Z" fill="currentColor" />;
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M11.6876 13.1631C11.1356 13.1631 10.6836 12.7161 10.6836 12.1631C10.6836 11.6101 11.1256 11.1631 11.6786 11.1631H11.6876C12.2396 11.1631 12.6876 11.6101 12.6876 12.1631C12.6876 12.7161 12.2396 13.1631 11.6876 13.1631Z" fill="currentColor" />;
    t5 = <path fillRule="evenodd" clipRule="evenodd" d="M7.67783 13.1631C7.12583 13.1631 6.67383 12.7161 6.67383 12.1631C6.67383 11.6101 7.11683 11.1631 7.66883 11.1631H7.67783C8.22983 11.1631 8.67783 11.6101 8.67783 12.1631C8.67783 12.7161 8.22983 13.1631 7.67783 13.1631Z" fill="currentColor" />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== props || $[8] !== size) {
    t6 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}{t3}{t4}{t5}</Svg>;
    $[7] = props;
    $[8] = size;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}

/** Профиль: шапка, нижнее меню. Figma: «Outline/Profile». */
export function ProfileIcon(t0) {
  const $ = _c(8);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M11.889 12.619H11.921C14.849 12.619 17.23 10.238 17.23 7.31C17.23 4.382 14.849 2 11.921 2C8.99202 2 6.61002 4.382 6.61002 7.307C6.60002 10.227 8.96702 12.61 11.889 12.619ZM8.03802 7.31C8.03802 5.169 9.78002 3.428 11.921 3.428C14.061 3.428 15.802 5.169 15.802 7.31C15.802 9.45 14.061 11.192 11.921 11.192H11.892C9.76002 11.184 8.03102 9.444 8.03802 7.31Z" fill="currentColor" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M4 18.1733C4 21.8703 9.962 21.8703 11.921 21.8703C15.32 21.8703 19.84 21.4893 19.84 18.1933C19.84 14.4963 13.88 14.4963 11.921 14.4963C8.521 14.4963 4 14.8773 4 18.1733ZM5.5 18.1733C5.5 16.7283 7.66 15.9963 11.921 15.9963C16.181 15.9963 18.34 16.7353 18.34 18.1933C18.34 19.6383 16.181 20.3703 11.921 20.3703C7.66 20.3703 5.5 19.6313 5.5 18.1733Z" fill="currentColor" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props || $[6] !== size) {
    t4 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}{t3}</Svg>;
    $[5] = props;
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}

/** Лупа в поле поиска шапки. Figma: «Outline/Search». */
export function SearchIcon(t0) {
  const $ = _c(8);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M7.82665 2.33301C4.79798 2.33301 2.33398 4.79634 2.33398 7.82501C2.33398 10.8537 4.79798 13.3177 7.82665 13.3177C10.8547 13.3177 13.3187 10.8537 13.3187 7.82501C13.3187 4.79634 10.8547 2.33301 7.82665 2.33301ZM7.82665 14.3177C4.24665 14.3177 1.33398 11.405 1.33398 7.82501C1.33398 4.24501 4.24665 1.33301 7.82665 1.33301C11.4067 1.33301 14.3187 4.24501 14.3187 7.82501C14.3187 11.405 11.4067 14.3177 7.82665 14.3177Z" fill="currentColor" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M14.3436 15.1479C14.2163 15.1479 14.0883 15.0992 13.9903 15.0019L11.641 12.6592C11.4456 12.4639 11.445 12.1472 11.6403 11.9519C11.835 11.7552 12.1516 11.7565 12.3476 11.9505L14.697 14.2939C14.8923 14.4892 14.893 14.8052 14.6976 15.0005C14.6003 15.0992 14.4716 15.1479 14.3436 15.1479Z" fill="currentColor" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props || $[6] !== size) {
    t4 = <Svg size={size} viewBox="0 0 16 16" {...props}>{t2}{t3}</Svg>;
    $[5] = props;
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}

/** Лупа в поиске города («Смена города»). Figma: «Outline/Search». */
export function Search20Icon(t0) {
  const $ = _c(8);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 20 : t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M9.78185 2.91675C5.99602 2.91675 2.91602 5.99591 2.91602 9.78175C2.91602 13.5676 5.99602 16.6476 9.78185 16.6476C13.5668 16.6476 16.6468 13.5676 16.6468 9.78175C16.6468 5.99591 13.5668 2.91675 9.78185 2.91675ZM9.78185 17.8976C5.30685 17.8976 1.66602 14.2567 1.66602 9.78175C1.66602 5.30675 5.30685 1.66675 9.78185 1.66675C14.2568 1.66675 17.8968 5.30675 17.8968 9.78175C17.8968 14.2567 14.2568 17.8976 9.78185 17.8976Z" fill="currentColor" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M17.9291 18.9348C17.7699 18.9348 17.6099 18.874 17.4874 18.7523L14.5507 15.824C14.3066 15.5798 14.3057 15.184 14.5499 14.9398C14.7932 14.694 15.1891 14.6957 15.4341 14.9382L18.3707 17.8673C18.6149 18.1115 18.6157 18.5065 18.3716 18.7507C18.2499 18.874 18.0891 18.9348 17.9291 18.9348Z" fill="currentColor" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props || $[6] !== size) {
    t4 = <Svg size={size} viewBox="0 0 20 20" {...props}>{t2}{t3}</Svg>;
    $[5] = props;
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}

/** Каталог: нижнее меню телефона. Figma: «Outline/Category». */
export function CategoryIcon(t0) {
  const $ = _c(10);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M6.25 3.5C3.5 3.5 3.5 3.708 3.5 6.25V6.275C3.5 7.382 3.5 8.182 3.771 8.52C4.036 8.848 4.823 9 6.25 9C7.677 9 8.464 8.847 8.729 8.519C9 8.182 9 7.382 9 6.274C9 3.708 9 3.5 6.25 3.5ZM6.25 10.5C4.564 10.5 3.299 10.323 2.604 9.46C2 8.711 2 7.689 2 6.275L2.75 6.25H2C2 3.38 2.181 2 6.25 2C10.319 2 10.5 3.38 10.5 6.25C10.5 7.688 10.5 8.711 9.896 9.46C9.201 10.323 7.936 10.5 6.25 10.5Z" fill="currentColor" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M17.25 3.5C14.5 3.5 14.5 3.708 14.5 6.25V6.275C14.5 7.382 14.5 8.182 14.771 8.52C15.036 8.848 15.823 9 17.25 9C18.677 9 19.464 8.847 19.729 8.519C20 8.182 20 7.382 20 6.274C20 3.708 20 3.5 17.25 3.5ZM17.25 10.5C15.564 10.5 14.299 10.323 13.604 9.46C13 8.711 13 7.689 13 6.275L13.75 6.25H13C13 3.38 13.181 2 17.25 2C21.319 2 21.5 3.38 21.5 6.25C21.5 7.688 21.5 8.711 20.896 9.46C20.201 10.323 18.936 10.5 17.25 10.5Z" fill="currentColor" />;
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M6.25 14.5C3.5 14.5 3.5 14.708 3.5 17.25V17.275C3.5 18.382 3.5 19.182 3.771 19.52C4.036 19.848 4.823 20 6.25 20C7.677 20 8.464 19.847 8.729 19.519C9 19.182 9 18.382 9 17.274C9 14.708 9 14.5 6.25 14.5ZM6.25 21.5C4.564 21.5 3.299 21.323 2.604 20.46C2 19.711 2 18.689 2 17.275L2.75 17.25H2C2 14.38 2.181 13 6.25 13C10.319 13 10.5 14.38 10.5 17.25C10.5 18.688 10.5 19.711 9.896 20.46C9.201 21.323 7.936 21.5 6.25 21.5Z" fill="currentColor" />;
    t5 = <path fillRule="evenodd" clipRule="evenodd" d="M17.25 14.5C14.5 14.5 14.5 14.708 14.5 17.25V17.275C14.5 18.382 14.5 19.182 14.771 19.52C15.036 19.848 15.823 20 17.25 20C18.677 20 19.464 19.847 19.729 19.519C20 19.182 20 18.382 20 17.274C20 14.708 20 14.5 17.25 14.5ZM17.25 21.5C15.564 21.5 14.299 21.323 13.604 20.46C13 19.711 13 18.689 13 17.275L13.75 17.25H13C13 14.38 13.181 13 17.25 13C21.319 13 21.5 14.38 21.5 17.25C21.5 18.688 21.5 19.711 20.896 20.46C20.201 21.323 18.936 21.5 17.25 21.5Z" fill="currentColor" />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  let t6;
  if ($[7] !== props || $[8] !== size) {
    t6 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}{t3}{t4}{t5}</Svg>;
    $[7] = props;
    $[8] = size;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}

/** Главная (залитая, активная): нижнее меню телефона. Figma: «Bold/Home». */
export function HomeBoldIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M9.13478 20.7733V17.7156C9.13478 16.9351 9.77217 16.3023 10.5584 16.3023H13.4326C13.8102 16.3023 14.1723 16.4512 14.4393 16.7163C14.7063 16.9813 14.8563 17.3408 14.8563 17.7156V20.7733C14.8539 21.0978 14.9821 21.4099 15.2124 21.6402C15.4427 21.8705 15.7561 22 16.0829 22H18.0438C18.9596 22.0023 19.8388 21.6428 20.4872 21.0008C21.1356 20.3588 21.5 19.487 21.5 18.5778V9.86686C21.5 9.13246 21.1721 8.43584 20.6046 7.96467L13.934 2.67587C12.7737 1.74856 11.1111 1.7785 9.98539 2.74698L3.46701 7.96467C2.87274 8.42195 2.51755 9.12064 2.5 9.86686V18.5689C2.5 20.4639 4.04738 22 5.95617 22H7.87229C8.55123 22 9.103 21.4562 9.10792 20.7822L9.13478 20.7733Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}

/** Колокольчик: подписка на магазин в избранном, уведомления. Figma: «Outline/Notification». */
export function BellIcon(t0) {
  const $ = _c(8);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M12.2461 2.5C8.75109 2.5 6.31509 5.238 6.31509 7.695C6.31509 9.774 5.73809 10.735 5.22809 11.583C4.81909 12.264 4.49609 12.802 4.49609 13.971C4.66309 15.857 5.90809 16.848 12.2461 16.848C18.5491 16.848 19.8331 15.813 19.9991 13.906C19.9961 12.802 19.6731 12.264 19.2641 11.583C18.7541 10.735 18.1771 9.774 18.1771 7.695C18.1771 5.238 15.7411 2.5 12.2461 2.5ZM12.247 18.348C7.57101 18.348 3.34501 18.018 3.00001 14.035C2.99701 12.387 3.50001 11.549 3.94401 10.811C4.39301 10.063 4.81601 9.358 4.81601 7.695C4.81601 4.462 7.80201 1 12.247 1C16.692 1 19.678 4.462 19.678 7.695C19.678 9.358 20.101 10.063 20.55 10.811C20.994 11.549 21.497 12.387 21.497 13.971C21.148 18.018 16.923 18.348 12.247 18.348Z" fill="currentColor" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M12.201 22.4996H12.199C11.078 22.4986 10.017 22.0046 9.21196 21.1076C8.93496 20.8006 8.95996 20.3256 9.26796 20.0496C9.57596 19.7716 10.05 19.7966 10.327 20.1056C10.845 20.6826 11.51 20.9996 12.2 20.9996H12.201C12.894 20.9996 13.562 20.6826 14.081 20.1046C14.359 19.7976 14.833 19.7726 15.14 20.0496C15.448 20.3266 15.473 20.8016 15.196 21.1086C14.388 22.0056 13.325 22.4996 12.201 22.4996Z" fill="currentColor" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props || $[6] !== size) {
    t4 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}{t3}</Svg>;
    $[5] = props;
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}

/** Колокольчик перечёркнутый: отписка от магазина в избранном. Figma: «Outline/Notification (перечёркнутый, отписка) — FRAME». */
export function BellOffIcon(t0) {
  const $ = _c(9);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  let t3;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M12.2461 2.5C8.75109 2.5 6.31509 5.238 6.31509 7.695C6.31509 9.774 5.73809 10.735 5.22809 11.583C4.81909 12.264 4.49609 12.802 4.49609 13.971C4.66309 15.857 5.90809 16.848 12.2461 16.848C18.5491 16.848 19.8331 15.813 19.9991 13.906C19.9961 12.802 19.6731 12.264 19.2641 11.583C18.7541 10.735 18.1771 9.774 18.1771 7.695C18.1771 5.238 15.7411 2.5 12.2461 2.5ZM12.247 18.348C7.57101 18.348 3.34501 18.018 3.00001 14.035C2.99701 12.387 3.50001 11.549 3.94401 10.811C4.39301 10.063 4.81601 9.358 4.81601 7.695C4.81601 4.462 7.80201 1 12.247 1C16.692 1 19.678 4.462 19.678 7.695C19.678 9.358 20.101 10.063 20.55 10.811C20.994 11.549 21.497 12.387 21.497 13.971C21.148 18.018 16.923 18.348 12.247 18.348Z" fill="currentColor" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M12.201 22.4996H12.199C11.078 22.4986 10.017 22.0046 9.21196 21.1076C8.93496 20.8006 8.95996 20.3256 9.26796 20.0496C9.57596 19.7716 10.05 19.7966 10.327 20.1056C10.845 20.6826 11.51 20.9996 12.2 20.9996H12.201C12.894 20.9996 13.562 20.6826 14.081 20.1046C14.359 19.7976 14.833 19.7726 15.14 20.0496C15.448 20.3266 15.473 20.8016 15.196 21.1086C14.388 22.0056 13.325 22.4996 12.201 22.4996Z" fill="currentColor" />;
    t4 = <path fillRule="evenodd" clipRule="evenodd" d="M4.11303 20.6361C3.92103 20.6361 3.72903 20.5631 3.58303 20.4161C3.29003 20.1231 3.29003 19.6491 3.58303 19.3561L19.357 3.58205C19.65 3.28905 20.124 3.28905 20.417 3.58205C20.71 3.87505 20.71 4.35005 20.417 4.64305L4.64303 20.4161C4.49703 20.5631 4.30503 20.6361 4.11303 20.6361Z" fill="currentColor" />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props || $[7] !== size) {
    t5 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}{t3}{t4}</Svg>;
    $[6] = props;
    $[7] = size;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}

/** Закрыть: шторки, окна (Outline/Close). Figma: «Outline/Close». */
export function CloseIcon(t0) {
  const $ = _c(8);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fillRule="evenodd" clipRule="evenodd" d="M18.5303 5.46967C18.8232 5.76256 18.8232 6.23744 18.5303 6.53033L6.53033 18.5303C6.23744 18.8232 5.76256 18.8232 5.46967 18.5303C5.17678 18.2374 5.17678 17.7626 5.46967 17.4697L17.4697 5.46967C17.7626 5.17678 18.2374 5.17678 18.5303 5.46967Z" fill="currentColor" />;
    t3 = <path fillRule="evenodd" clipRule="evenodd" d="M5.46967 5.46967C5.76256 5.17678 6.23744 5.17678 6.53033 5.46967L18.5303 17.4697C18.8232 17.7626 18.8232 18.2374 18.5303 18.5303C18.2374 18.8232 17.7626 18.8232 17.4697 18.5303L5.46967 6.53033C5.17678 6.23744 5.17678 5.76256 5.46967 5.46967Z" fill="currentColor" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props || $[6] !== size) {
    t4 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}{t3}</Svg>;
    $[5] = props;
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}

/** Отправить сообщение (самолётик, залитый): поле чата. Figma: «Bold/Send». */
export function SendIcon(t0) {
  const $ = _c(7);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M21.4354 2.58198C20.9352 2.0686 20.1949 1.87734 19.5046 2.07866L3.408 6.75952C2.6797 6.96186 2.16349 7.54269 2.02443 8.28055C1.88237 9.0315 2.37858 9.98479 3.02684 10.3834L8.0599 13.4768C8.57611 13.7939 9.24238 13.7144 9.66956 13.2835L15.4329 7.4843C15.723 7.18231 16.2032 7.18231 16.4934 7.4843C16.7835 7.77623 16.7835 8.24935 16.4934 8.55134L10.72 14.3516C10.2918 14.7814 10.2118 15.4508 10.5269 15.9702L13.6022 21.0538C13.9623 21.6577 14.5826 22 15.2628 22C15.3429 22 15.4329 22 15.513 21.9899C16.2933 21.8893 16.9135 21.3558 17.1436 20.6008L21.9156 4.52479C22.1257 3.84028 21.9356 3.09537 21.4354 2.58198Z" fill="currentColor" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== size) {
    t3 = <Svg size={size} viewBox="0 0 24 24" {...props}>{t2}</Svg>;
    $[4] = props;
    $[5] = size;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}